import { UnhandledAPIError } from './UnhandledAPIError'

export class ConflictAPIError extends UnhandledAPIError {}
